/**
 *
 * @returns {Function}
 */
export const initializePlugin = (() => {
  const pluginsInitialized = [];

  return ({ player, name, options }) => {
    if (player[name] && typeof player[name] === 'function') {
      if (!pluginsInitialized.includes(name)) {
        player[name](options);
        pluginsInitialized.push(name);
      }
    }
  };
})();

/**
 * Accepts some arguments which will construct options based on the current <VideoPlayer/>.
 * These options can later be used to dynamically initialize a plugin on the video.js instance:
 *
 *  For example: videoInstance.myPlugin(options);
 *
 * @param config  Object with plugin configuration options
 * @param props   Props from the <VideoPlayer/>
 * @param state   State from the <VideoPlayer/>
 */
export const preparePluginOptions = ({ name, config, props, state }) => {
  const { mapPropStateToOptions } = config;

  // If options is a function, call it with the <VideoPlayer/>'s props and state,
  // this should return an object.
  // Otherwise `options` can be a regular object.
  const pluginOpts =
    typeof mapPropStateToOptions === 'function'
      ? mapPropStateToOptions.apply(this, [props, state])
      : mapPropStateToOptions;

  // Options can be a Promise when it needs to do some async work, such as the
  // ima plugin which loads some ad data from an external server.
  // In that case we initialize the plugin once the promise is resolved.
  if (pluginOpts instanceof Promise) {
    return pluginOpts.then((options) => ({
      name,
      options,
    }));
  }

  return Promise.resolve({
    name,
    options: pluginOpts,
  });
};
